import { Skeleton, TextField } from "@mui/material";
import { Controller, get, useFormContext } from "react-hook-form";
import AutoComplete from "./AutoComplete";

const FieldLabel = ({ label, required }) => (
  <span>
    {label}
    {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
  </span>
);

const FormControlAutocomplete = ({ name, label, options, placeholder, required, control: controlProps, ...props }) => {
  const { control: controlContext } = useFormContext();
  const control = controlProps || controlContext;

  return (
    <>
      {props?.loading ? (
        <Skeleton />
      ) : (
        <Controller
          control={control}
          name={name}
          rules={{ required: true }}
          render={({ field, formState: { errors } }) => {
            const error = get(errors, name);
            return (
              <AutoComplete
                {...props}
                // Store the whole option object in form state
                onChange={(_, value) => {
                  props?.onChange?.(value);
                  field.onChange(value || null);
                }}
                // So khớp theo `value` (chuỗi hóa để tránh lệch ObjectId / string)
                isOptionEqualToValue={(option, value) => option != null && value != null && String(option?.value) === String(value?.value)}
                options={options || []}
                value={field.value || null}
                getOptionLabel={props?.getOptionLabel || ((option) => option?.label ?? "")}
                error={!!error}
                helperText={error?.message}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      !!label ? (
                        <FieldLabel
                          label={label}
                          required={required}
                        />
                      ) : null
                    }
                    placeholder={placeholder}
                    error={!!error}
                    helperText={error?.message}
                    disabled={props.disabled}
                    slotProps={{ formHelperText: { sx: { mx: "0px" } } }}
                  />
                )}
              />
            );
          }}
        />
      )}
    </>
  );
};

export default FormControlAutocomplete;
